export default __webpack_public_path__ + "static/media/logo.d4c8ef62.svg";